import React from "react";
import styled from "styled-components";
import { EyeOff16Regular } from "@fluentui/react-icons";
import CompareToggle from "../CompareToggle/CompareToggle";
import CompareInfo from "../CompareInfo/CompareInfo";
import { usePilotageRhStore } from "../../../store/usePilotageRhStore";
import useIndicatorsVisibility from "../../../hooks/useIndicatorsVisibility";
import { INDICATOR_GROUP_BY_SECTION } from "../../../constants";

/** En-tête de section : titre h2 + toggle de comparaison + nombre d'indicateurs masqués */
const SectionHeader = ({ sectionId, title }) => {
    const on = usePilotageRhStore((s) => !!s.compare[sectionId]);
    const toggleCompare = usePilotageRhStore((s) => s.toggleCompare);
    const openPrefPanel = usePilotageRhStore((s) => s.openPrefPanel);
    const { hiddenCountByGroup } = useIndicatorsVisibility();
    const hidden = hiddenCountByGroup(INDICATOR_GROUP_BY_SECTION[sectionId]);

    return (
        <Head>
            <Title>{title}</Title>
            <CompareToggle on={on} onToggle={() => toggleCompare(sectionId)} />
            <CompareInfo on={on} />
            {hidden > 0 && (
                <HiddenLink
                    type="button"
                    onClick={() => openPrefPanel(sectionId)}
                >
                    <EyeOff16Regular />
                    {hidden} indicateur{hidden > 1 ? "s" : ""} masqué
                    {hidden > 1 ? "s" : ""}
                </HiddenLink>
            )}
        </Head>
    );
};

export default SectionHeader;

const Head = styled.div`
    display: flex;
    align-items: center;
    gap: 11px;
    margin-bottom: 13px;
`;

const Title = styled.h2`
    font-size: var(--prh-font-xl);
    font-weight: 600;
    color: var(--prh-ink);
    margin: 0;
`;

const HiddenLink = styled.button`
    margin-left: auto;
    margin-top: 4px;
    padding: 4px 2px;
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    color: var(--prh-violet);
    font-size: var(--prh-font-sm);
    font-family: inherit;
    cursor: pointer;

    &:hover {
        color: var(--prh-violet-dark);
        text-decoration: underline;
    }
`;
